import { Dropdown, Menu } from 'antd';
import styled from 'styled-components';
import { IconButton } from '../icons/IconContainer';
import { SaveIcon } from '../icons/SaveIcon';


const StyledPrimaryButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0px 21px;
    border: none;
    background: ${({link, danger}) => link ? "transparent" :danger ? "var(--sp-error-hover-color)" : "var(--sp-main-color)"};
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    color: ${({link}) => link ? "var(--sp-main-color)" : "#FFFFFF"};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: ${({link, danger}) => link ? "#DBE9FF" : danger ? "#FF4E4E" : "var(--sp-main-color-hover)"};
    }

    &:focus {
        outline: none;
    }

    &:active > span {
        transform: translateY(1px);
    }

    & > span:not(:last-child) {
        margin-right: 8px;
    }

    &[disabled] {
        background: var(--sp-disabled-color);
        cursor: not-allowed;
    }

    &[disabled] span {
        color: rgba(50, 97, 175, .5);
        opacity: 0.8;
        fill-opacity: 0.8;
    }
`;

const Button = (props) => {
    return (
        <StyledPrimaryButton {...props}>
            {Array.isArray(props.children)
                ? props.children.map((child, idx) => <span key={`btn-text-${idx}`}>{child}</span>)
                : <span>{props.children}</span>}
        </StyledPrimaryButton>
    )
};

export { Button };

const StyledTextButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    padding: 0;
    background: transparent;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    color: ${({danger}) => danger ? "var(--sp-danger-color)" : "var(--sp-main-color-hover)"};
    cursor: pointer;
    transition: all 0.3s ease;
    max-width: ${({ maxWidth }) => maxWidth};

    & span {
        overflow: ${({maxWidth}) => maxWidth && "hidden"};
        text-overflow: ${({maxWidth}) => maxWidth && "ellipsis"};
    }

    &:hover {
        color: ${({danger}) => danger ? "var(--sp-danger-hover-color)" : "var(--sp-main-color)"};
    }

    &:focus {
        outline: none;
    }

    &:active > span {
        transform: translateY(1px);
    }

    & > span:not(:last-child) {
        margin-right: 8px;
    }

    &[disabled] {
        cursor: not-allowed;
    }

    &[disabled] span {
        color: var(--sp-disabled-text-color);
    }
`;

export const TextButton = (props) => (
    <StyledTextButton {...props}>
        {Array.isArray(props.children)
            ? props.children.map((child, idx) => <span key={`btn-text-${idx}`}>{child}</span>)
            : <span>{props.children}</span>}
    </StyledTextButton>
);

const StyledMenu = styled(Menu)`
    margin-top: ${({ margin }) => margin || 4}px;
`;

const StyledMenuItem = styled(Menu.Item)`
    &:not(.ant-dropdown-menu-item-disabled),
    &:not(.ant-dropdown-menu-item-disabled) a,
    &:not(.ant-dropdown-menu-item-disabled) a:hover {
        font-size: 14px;
        line-height: 19px;
        color: var(--sp-text-color);
    }
`;

export const DropdownButton = ({ items=[], onMenuClick, placement="bottomRight", ...props }) => {
    const menu = (
        <StyledMenu onClick={onMenuClick} {...props}>
            {items.map(item => (item &&
                <StyledMenuItem
                    key={item.key}
                    {...item}
                >
                    {item.title}
                </StyledMenuItem>
            ))}
        </StyledMenu>
    );

    return(
        <Dropdown overlay={menu} trigger={["click"]} placement={placement}>
            {props.children}
        </Dropdown>
    )
};

const StyledBorderedButton = styled.button`
    border: 1px solid #E4EDFD;
    border-radius: 8px;
    background: #FFFFFF;
    color: var(--sp-label-color);
    min-width: 44px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover, &:focus {
        border-color: #D2E1FC;
        color: var(--sp-main-color);
    }
`

export const BorderedButton = (props) =>
    <StyledBorderedButton {...props}>
        {props.children}
    </StyledBorderedButton>

export const ReportButton = ({ makeReport }) =>
    <ActionButton onClick={() => makeReport()}>
        <SaveIcon />
    </ActionButton>

export const ActionButton = ({ onClick, ...props }) =>
    <IconButton background="#FFFFFF" color="var(--sp-main-color)" hoverColor="var(--sp-main-color-hover)" onClick={onClick} {...props}>
        {props.children}
    </IconButton>